<template>
    <Head title="Termos de Uso e Políticas de Privacidade" />
    <div class="min-h-screen bg-primary grid grid-cols-1 md:grid-cols-2">
      <div class="flex items-center justify-center">
        <img src="/images/logo_home.png" width="346" height="135">
      </div>
      <div class="flex bg-white rounded-t-lg md:rounded-none md:rounded-l-lg max-h-screen overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-primary scrollbar-track-secondary">
        <div class="w-full pt-12 px-10">
            <div class="text-2xl font-bold text-center">Termos de Uso</div>
            <div class="mt-4 whitespace-pre-line">{{ terms_mobile }}</div>
            <div class="text-2xl font-bold text-center mt-7">Políticas de Privacidade</div>
            <div class="mt-4 pb-12 whitespace-pre-line">{{ privacy_mobile }}</div>
        </div>
      </div>
    </div>
    
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue3'
  
  export default {
    components: {
      Head,
    },
    props: {
        privacy_mobile: {
            type: String,
            default: ''
        },
        terms_mobile: {
            type: String,
            default: ''
        },
    },
  }
  </script>
  